import styled from "styled-components";

export const TextHead = styled.p`
  color: #1f2d3d;
  margin: 0;
  font-size: 24px;
  line-height: 34px;
  font-weight: bold;

  @media only screen and (min-width: 769px) {
    font-size: 28px;
    line-height: 37px;
  }
`;

export const TextRegular = styled.p`
  margin: 0;
  font-size: ${(props) => props?.fontSize ?? "14px"};
  line-height: 24px;
  color: #1f2d3d;

  @media only screen and (min-width: 769px) {
    font-size: ${(props) => props?.fontSize ?? "16px"};
    line-height: 24px;
  }
`;

export const Button = styled.button`
  display: flex;
  width: 100%;
  height: 44px;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  align-self: center;
  margin-top: 16px;
  color: white;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 40px;
  background-color: #00bcf1;
  @media only screen and (min-width: 768px) {
    max-width: 327px;
  }
`;
